jQuery(document).ready(function($){
  if ($('body').hasClass('page-id-149')) {

          var $carouselWrap = $('.carousel-vertical-timeline');
          var $panel = $('.carousel-vertical-slide');
          var $indicators = $('.carousel-indicators li');

          $(window).on('load resize scroll', function() {
              if ($(window).width() > 639) {
                  var $stickyTop = $('.carousel-vertical-timeline').offset().top;
                  var $stickyBottom = $('.carousel-vertical-timeline').offset().bottom;
                  if ($(window).scrollTop() >= $stickyTop - 116) {
                      $('.carousel-vertical-timeline').addClass('fixed');
                  } else {
                      $('.carousel-vertical-timeline').removeClass('fixed');
                  }
              }
          });

          $(window).on('resize scroll', function() {
              if ($(window).width() > 639) {
                  var scroll = $(window).scrollTop() + $(window).height();
                  var offset = $carouselWrap.offset().top + $carouselWrap.height();

                  if (scroll > offset) {
                      $('.carousel-vertical-timeline').removeClass('fixed');
                  }
              }
          });

          $.fn.isInViewport = function() {
              var elementTop = $(this).offset().top;
              var elementBottom = elementTop + $(this).outerHeight() * .5;
              var viewportTop = $(window).scrollTop();
              var viewportBottom = viewportTop + $(window).height() * .5;
              return elementBottom > viewportTop && elementTop < viewportBottom;
          };

          $(window).on('resize scroll', function() {
              if ($(window).width() > 639) {
                  if ($('#slide1').isInViewport()) {
                      $panel.add($indicators).removeClass('active');
                      $('#slide1, #indicator1').addClass('active');
                  } else if ($('#slide2').isInViewport()) {
                      $panel.add($indicators).removeClass('active');
                      $('#slide2, #indicator2').addClass('active');
                  } else if ($('#slide3').isInViewport()) {
                      $panel.add($indicators).removeClass('active');
                      $('#slide3, #indicator3').addClass('active');
                  } else if ($('#slide4').isInViewport()) {
                      $panel.add($indicators).removeClass('active');
                      $('#slide4, #indicator4').addClass('active');
                  } else if ($('#slide5').isInViewport()) {
                      $panel.add($indicators).removeClass('active');
                      $('#slide5, #indicator5').addClass('active');
                  }
              } else if ($(window).width() < 639){
                $panel.add($indicators).removeClass('active');
              }
          });

          $('#indicator1').click(function() {
              $('html, body').animate({
                  scrollTop: $('#slide1').offset().top
              }, 500);
          });
          $('#indicator2').click(function() {
              $('html, body').animate({
                  scrollTop: $('#slide2').offset().top
              }, 500);
          });
          $('#indicator3').click(function() {
              $('html, body').animate({
                  scrollTop: $('#slide3').offset().top
              }, 500);
          });
          $('#indicator4').click(function() {
              $('html, body').animate({
                  scrollTop: $('#slide4').offset().top
              }, 500);
          });
          $('#indicator5').click(function() {
              $('html, body').animate({
                  scrollTop: $('#slide5').offset().top
              }, 500);
          });

      }

})
